module.exports = __webpack_public_path__ + "img/tastings.db1f1c8c.png";